import { format } from "date-fns";

export const formatFeedDate = (raw) => {
  if (!raw) return "";
  const d = new Date(raw);
  if (isNaN(d.getTime())) return String(raw);
  return format(d, "EEE d MMMM yyyy HH:mm");
};
